import { Link } from "react-router-dom";
import content from "./content/index.json";

export default function Mainpage(): React.ReactElement {
  return (
    <ul>
      {content.files.map((filename) => (
        <li key={filename}>
          <Link to={filename}>{filename}</Link>
        </li>
      ))}
    </ul>
  );
}
